import axios from 'axios';

// API 기본 설정
const BASE_URL = process.env.REACT_APP_CAMPUS_API_BASE_URL || 'https://medaicampus.kr/gateway';

const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// 인터셉터 설정 - 토큰 자동 추가
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// 응답 인터셉터 - 에러 처리
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('access_token');
      window.location.href = '/admin/login';
      return Promise.reject(error);
    }
    const status = error.response?.status;
    if (status >= 400 && status < 500) {
      const serverMessage = error.response?.data?.message;
      if (serverMessage) {
        // 서버 메시지만 남기면 호출부가 상태 코드를 알 수 없으므로 함께 실어 보낸다.
        const serverError = new Error(serverMessage) as Error & { status?: number };
        serverError.status = status;
        return Promise.reject(serverError);
      }
    }
    return Promise.reject(error);
  }
);

export { apiClient, BASE_URL };
